module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//green_2.png?v=56202576";